import Vue from 'vue'
import '@babel/polyfill'
import { app } from './app'
import auth from './auth/index'
import packageInfo from '../package.json'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

// Initialize Sentry with the variables given in the .env file if its either in a dev or prod environment
if (process.env.APP_ENV === 'Testing' || process.env.APP_ENV === 'Production') {
  Sentry.init({
    release: 'compliance_nl@' + packageInfo.version,
    dsn: `https://${process.env.SENTRY_KEY}@sentry.io/${process.env.SENTRY_PROJECT}`,
    integrations: [new Integrations.Vue({ Vue })],
    environment: process.env.APP_ENV,
    beforeBreadcrumb(breadcrumb, hint) {
      const target = hint?.event?.target
      if (breadcrumb.category === 'ui.click') {
        if (target.innerText) breadcrumb.message = `(${target.innerText.trim()}) ${breadcrumb.message}`
        else if (target.outerText) breadcrumb.message = `(${target.outerText.trim()}) ${breadcrumb.message}`
        else if (target.placeholder) breadcrumb.message = `(${target.placeholder.trim()}) ${breadcrumb.message}`
      }
      return breadcrumb
    }
  })
}

auth.checkAuthenticated(app)

app.$mount('#root')
